module.exports = __webpack_public_path__ + "media/images/vp/icon.phone.red-67d80b5e7e1257dd90f97a620d0e218d.svg";